import { ObservableArray, ViewModel } from "binder";
import { SendToLocalNotificationMessage } from "src/server/localNotification";
import { TagSheetSpecs } from "./warehouseKeepingDetail/warehouseKeepingDetail-viewModel";

export class printTagSheetAction{
    public async Print(parent: ViewModel, info:ObservableArray<TagSheetSpecs>){
        let message = new SendToLocalNotificationMessage('requestPrint', {
            Form:"TagSheet",
            Data:{
                CopyCount: 1,
                TagSheetItems: info.map(x => {
                   return {
                    WarehouseName: x.WarehouseName,
                    ProductCode: x.ProductCode,
                    ProductName: x.ProductName,
                    Unit: x.Unit,
                    Location: x.Location,
                    Year: x.Year,
                    FirstCountedNumber: x.FirstCountedNumber,
                    FirstCountingPersonName: x.FirstCountingPersonName,
                    FirstCountingDate: x.FirstCountingDate,
                    FirstCounter: x.FirstCounter,
                    FirstTagNumber: x.FirstTagNumber,
                    SecondCountedNumber: x.SecondCountedNumber,
                    SecondCountingPersonName: x.SecondCountingPersonName,
                    SecondCountingDate: x.SecondCountingDate,
                    SecondCounter: x.SecondCounter,
                    SecondTagNumber: x.SecondTagNumber,
                    ThirdCountedNumber: x.ThirdCountedNumber,
                    ThirdCountingPersonName: x.ThirdCountingPersonName,
                    ThirdCountingDate: x.ThirdCountingDate,
                    ThirdCounter: x.ThirdCounter,
                    ThirdTagNumber: x.ThirdTagNumber
                   }; 
                })
            }
        });
        parent.handleMessage(message);
    }
}